export const formatDate = (str) => {
  const d = new Date(str);
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone:'UTC' };
  return d.toLocaleDateString('en-EN', options);
}